import React, { useEffect, useState } from "react";
import { Text, View, TouchableOpacity } from "react-native";
import styles from "../styles/Styles";
import Emoji from 'react-native-emoji';

const MemberListCard = ({ navigation, members }) => {
  return (
    <View>
      {members.map((member) => (
        <View style={styles.listTab} key={member.name}>
          <Text style={styles.listText}>{member.name}</Text>
          <View style={{flex: 1, flexDirection: 'row'}}>
            <TouchableOpacity 
              style={styles.featureCard}
              onPress={() => navigation.navigate("Check-in Records", { member })}
            >
                <Emoji name="memo" style={{fontSize: 50}}/>
            </TouchableOpacity>
            <TouchableOpacity 
              style={styles.featureCard}
              onPress={() => navigation.navigate("Emergency Contact", { member })}
            >
                <Emoji name="telephone_receiver" style={{fontSize: 50}}/>
            </TouchableOpacity>
          </View>
        </View>
      ))}
    </View>
  );
};

export default MemberListCard;
